import React, {useState, useEffect} from "react";

const Square = ({SqKey, sqNum, val, onClick, highlight}) => {

    return (
        <div className={`square ${SqKey} ${val} ${highlight}`} onClick={() => onClick(sqNum)}>{sqNum + " " + val}</div>
    )
}

export default Square